import React from 'react'
import { Modal as ReactModal } from 'react-responsive-modal'

import 'react-responsive-modal/styles.css'
import './style.css'

const classNames = {
    modal: 'customModal',
    closeButton: 'customCloseButton',
}

const styles = {
    modal: {
        maxHeight: 700,
    },
}

const Modal = ({ isModalOpen, onCloseModal, ...rest }) => {
    return (
        <ReactModal
            classNames={classNames}
            open={isModalOpen}
            onClose={onCloseModal}
            center
            styles={styles}
            {...rest}
        />
    )
}

export { Modal }
